const threeDimentional =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/three_dimentional.svg';
const flat_minimalist =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/flat_minimalist.svg';
const hand_drawn = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/hand_drawn.svg';
const mascot_cartoon =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/mascot_cartoon.svg';
const retro = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/retro.svg';
const signature = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/signature.svg';
const watercolor_feminine =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/watercolor_feminine.svg';
const thumbnails = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/thumbnails.svg';
const panels = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/panels.svg';
const overlays_screen_packs =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/overlays_screen_packs.svg';
const emotes_badges =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/emotes_badges.svg';
const banners = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/banners.svg';
const alerts = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/alerts.svg';
const ads_social_media_videos =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/ads_social_media_videos.svg';
const corporate_videos =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/corporate_videos.svg';
const elearning = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/elearning.svg';
const event_videos =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/event_videos.svg';
const explainer_videos =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/explainer_videos.svg';
const family_videos =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/family_videos.svg';
const gaming_videos =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/gaming_videos.svg';
const movie_trailers =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/movie_trailers.svg';
const music_videos =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/music_videos.svg';
const showreels = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/showreels.svg';
const fiction_films =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/fiction_films.svg';
const vr_360_video =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/vr_360_video.svg';
const view_all = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/view_all.svg';
const male = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/male.svg';
const female = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/female.svg';
const arabic = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/arabic.svg';

const english = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/english.png';
const french = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/french.svg';
const german = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/german.svg';
const italian = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/italian.svg';
const spanish = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/spanish.svg';
const dutch = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/dutch.svg';
const beauty_fashion =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/beauty_fashion.svg';
const business_finance_law =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/business_finance_law.svg';
const health_medical =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/health_medical.svg';
const internet_technology =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/internet_technology.svg';
const lifestyle = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/lifestyle.svg';
const marketing = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/marketing.svg';
const facebook = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/facebook.svg';
const twitter = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/twitter.svg';
const etsy = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/etsy.svg';
const instagram = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/instagram.svg';
const linkedin = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/linkedin.svg';
const youtube = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/youtube.svg';
const investor_pitch_fundraising =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/investor_pitch_fundraising.svg';
const business_proposal =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/business_proposal.svg';
const education_training =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/education_training.svg';
const sales = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/sales.svg';
const conference = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/conference.svg';
const shopify = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/shopify.svg';
const amazon = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/amazon.svg';
const ebay = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/ebay.svg';
const woocommerce =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/woocommerce.svg';
const wix = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/wix.svg';
const wordpress = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/wordpress.svg';
const magento = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/magento.svg';
const opencart = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/opencart.svg';
const bigcommerce =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/bigcommerce.svg';
const prestashop = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/prestashop.svg';
const squarespace =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/squarespace.svg';
const godaddy = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/godaddy.svg';
const sitebuilder =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/sitebuilder.svg';
const webflow = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/webflow.svg';
const blog = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/blog.svg';
const business = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/business.svg';
const education = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/education.svg';
const portfolio = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/portfolio.svg';
const entertainment =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/entertainment.svg';
const wedding = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/wedding.svg';
const sports_games =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/sport_games.svg';
const guitar = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/guitar.svg';
const drums = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/drums.svg';
const bass = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/bass.svg';
const piano = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/piano.svg';
const keyboards = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/keyboards.svg';
const pop = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/pop.svg';
const hip_hop = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/hip_hop.svg';
const rap = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/rap.svg';
const r_b = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/r_b.svg';
const edm = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/edm.svg';
const illustrative =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/illustrative.svg';
const photographic =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/photographic.svg';
const typographic =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/typographic.svg';
const digital =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/digital-pattern.svg';
const hand_drawn_pattern =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/hand_drawn-pattern.svg';

const for_children =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/for_children.svg';
const realistic_drawing =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/realistic_drawing.png';
const comic_cartoon =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/comic_cartoon.png';
const manga = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/manga.png';
const flat = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/flat.png';

const line_art = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/line_art.png';
const sketch = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/sketch.png';
const mysql = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/mysql.svg';
const ms_sql = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/ms_sql.svg';
const access = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/access.svg';
const oracle = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/oracle.svg';
const sqlite = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/sqlite.svg';
const postgres = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/postgres.svg';
const mongo = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/mongo.svg';
const teradata = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/teradata.svg';

const freehand_digital =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/freehand_digital.png';
const pen_ink = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/pen_ink.png';
const vector_art = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/vector_art.png';
const mixed_media =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/mixed_media.png';
const watercolor = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/watercolor.png';
const pencil = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/pencil.png';
const fiction = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/fiction.svg';
const non_fiction =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/non_fiction.svg';
const self_help_wellness =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/self_help_wellness.svg';
const children_s_books =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/children_books.svg';
const science_fiction_fantasy =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/science_fiction_fantasy.svg';
const romance = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/romance.svg';
const google = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/google.svg';
const bing = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/bing.svg';
const excel = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/excel.svg';
const word = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/word.svg';
const power_bi = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/power_bi.svg';
const google_data_studio =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/google_data_studio.svg';
const arcgis = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/arcgis.svg';
const qgis = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/qgis.svg';
const google_earth_pro =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/google_earth_pro.svg';
const tableau = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/tableau.svg';
const d3_js = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/dThree.svg';
const google_sheets =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/google_sheets.svg';
const google_analytics =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/google_analytics.svg';
const python = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/python.svg';
const r = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/r.svg';
const spss = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/spss.svg';
const house = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/house.svg';
const trap = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/trap.svg';
const lofi = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/lofi.svg';
const dancehall = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/dancehall.svg';
const future_bass =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/future_bass.svg';
const drill = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/drill.svg';
const male_singer =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/male_singer.svg';
const female_singer =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/female_singer.svg';
const non_binary = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/non_binary.svg';
const streamlabs_obs =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/streamlabs_obs.svg';
const obs_studio = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/obs_studio.svg';

const streamelements =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/streamelements.svg';
const twitch_app = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/twitch_app.svg';
const ios_android_dual =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/ios_android_dual.svg';
const android_app =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/android_app.svg';
const iphone_ipad_app =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/iphone_ipad_app.svg';
const mobile_web = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/mobile_web.svg';
const windows_mobile_app =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/windows_mobile_app.svg';
const html_css = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/html_css.svg';
const javascript = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/javascript.svg';
const php = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/php.svg';

const asp_net = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/asp_net.svg';
const java = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/java.svg';
const c = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/c.svg';
const c_sharp = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/c_sharp.svg';
const html = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/html.svg';
const css = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/css.svg';
const unisex = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/unisex.svg';
const clothing = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/clothing.svg';
const shoes = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/shoes.svg';
const accessories =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/accessories.svg';
const bags = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/bags.svg';
const modular_systems_booth =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/modular_systems_booth.svg';
const custom_made_booth =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/custom_made_booth.svg';
const t_shirts = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/t_shirts.svg';
const clothing_apparel =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/clothing_apparel.svg';
const mugs = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/mugs.svg';
const hats = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/hats.svg';
const building = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/building.svg';
const building_complex =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/building_complex.svg';
const object = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/object.svg';
const apartment = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/apartment.svg';
const room = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/room.svg';
const neighborhood =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/neighborhood.svg';
const city = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/city.svg';

const portrait = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/portrait.svg';
const pet_portrait =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/pet_portrait.svg';
const caricature = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/caricature.svg';
const seller_provides_location =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/white_background.svg';
const client_provides_location =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/indoor_lifestyle.svg';
const screencasting =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/outdoor_lifestyle.svg';
const three_hundred_sixty =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/three_hundred_sixty.svg';
const black_background =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/black_background.svg';
const animated = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/animated.svg';
const live_action =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/live_action.svg';
const generic = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/generic.svg';
const tiktok = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/tiktok.svg';
const snapchat = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/snapchat.svg';
const pinterest = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/pinterest.svg';
const illustration =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/Illustration.svg';
const infographics =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/infographics.svg';
const text_animation =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/text_animation.svg';
const women = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/women.svg';
const men = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/men.svg';

const watercolor_pattern =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/watercolor_pattern.svg';
const collage_pattern =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/collage_pattern.svg';
const realistic_pattern =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/realistic_pattern.svg';
const cartoon_pattern =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/cartoon_pattern.svg';
const abstract_pattern =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/abstract_pattern.svg';

const geometric = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/geometric.svg';
const lettering = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/lettering.svg';
const youtube_videos =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/youtube_videos.svg';
const full_outfit =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/full_outfit.svg';
const kids = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/kids.svg';
const valorant = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/valorant.svg';

const minecraft = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/minecraft.svg';
const league_of_legends =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/league_of_legends.svg';
const fortnite = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/fortnite.svg';

const apex_legends =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/apex_legends.svg';
const roblox = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/roblox.svg';
const call_of_duty =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/call_of_duty.svg';
const counter_strike =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/counter_strike.svg';
const rocket_league =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/rocket_league.svg';
const hoodies = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/hoodies.svg';
const stickers = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/stickers.svg';
const socks = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/socks.svg';
const jerseys_sportswear =
    'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/jerseys_sportswear.svg';
const violin = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/violin.svg';
const saxophone = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/saxophone.svg';
const trumpet = 'https://fiverr-res.cloudinary.com/image/upload/v1789572018/listings_assets/metadata/trumpet.svg';

const unity = 'https://fiverr-res.cloudinary.com/image/upload/v1790059414/listings_assets/metadata/unity.svg';
const unreal_engine =
    'https://fiverr-res.cloudinary.com/image/upload/v1790059442/listings_assets/metadata/unreal_engine.svg';
const fivem = 'https://fiverr-res.cloudinary.com/image/upload/v1790059280/listings_assets/metadata/fivem.svg';
const godot = 'https://fiverr-res.cloudinary.com/image/upload/v1790059317/listings_assets/metadata/godot.svg';
const roblox_game_engine =
    'https://fiverr-res.cloudinary.com/image/upload/v1790059355/listings_assets/metadata/roblox.svg';
const illustrative_design_style =
    'https://fiverr-res.cloudinary.com/image/upload/v1790059052/listings_assets/metadata/illustrative.svg';
const typographic_design_style =
    'https://fiverr-res.cloudinary.com/image/upload/v1790059241/listings_assets/metadata/typographic.svg';
const photographic_design_style =
    'https://fiverr-res.cloudinary.com/image/upload/v1790059168/listings_assets/metadata/photographic.svg';
const minimalistic =
    'https://fiverr-res.cloudinary.com/image/upload/v1790059102/listings_assets/metadata/minimalistic.svg';
const twoD_animation = 'https://fiverr-res.cloudinary.com/image/upload/v1790058975/listings_assets/metadata/2d.svg';
const threeD_animation = 'https://fiverr-res.cloudinary.com/image/upload/v1790059024/listings_assets/metadata/3d.svg';
const stop_motion =
    'https://fiverr-res.cloudinary.com/image/upload/v1790059203/listings_assets/metadata/stop_motion.svg';

export default {
    515: {
        wordpress,
        wix,
        webflow,
        shopify,
        woocommerce,
    },
    512: {
        valorant,
        minecraft,
        league_of_legends,
        fortnite,
        apex_legends,
        roblox,
        call_of_duty,
        counter_strike,
        rocket_league,
    },
    335: {
        english,
        german,
        spanish,
        french,
        italian,
    },
    228: {
        illustration,
        infographics,
        text_animation,
    },
    329: {
        facebook,
        generic,
        instagram,
        youtube,
        tiktok,
        snapchat,
        pinterest,
        linkedin,
        twitter,
    },
    234: {
        animated,
        live_action,
    },
    332: {
        seller_provides_location,
        client_provides_location,
        screencasting,
        black_background,
        360: three_hundred_sixty,
    },
    340: {
        portrait,
        pet_portrait,
        caricature,
    },
    150: {
        building,
        building_complex,
        object,
        apartment,
        neighborhood,
        room,
        city,
    },
    154: {
        t_shirts,
        clothing_apparel,
        mugs,
        accessories,
        hats,
        hoodies,
        stickers,
        socks,
        jerseys_sportswear,
    },
    419: {
        modular_systems_booth,
        custom_made_booth,
    },
    441: {
        women,
        men,
        unisex,
        clothing,
        shoes,
        accessories,
        bags,
        full_outfit,
        kids,
    },
    416: {
        python,
        c,
        javascript,
        java,
        html,
        css,
    },
    140: {
        html_css,
        javascript,
        python,
        php,
        asp_net,
        java,
        c: c_sharp,
    },
    141: {
        ios_android_dual,
        android_app,
        iphone_ipad_app,
        mobile_web,
        windows_mobile_app,
    },
    425: {
        streamlabs_obs,
        obs_studio,
        streamelements,
        twitch_app,
    },
    158: {
        male: male_singer,
        female: female_singer,
        non_binary,
    },
    432: {
        hip_hop,
        pop,
        r_b,
        edm,
        house,
        trap,
        lofi,
        dancehall,
        rap,
        future_bass,
        drill,
    },
    454: {
        excel,
        word,
        power_bi,
        google_data_studio,
        arcgis,
        qgis,
        google_earth_pro,
        tableau,
        d3_js,
        google_sheets,
        spss,
        r,
        google_analytics,
        python,
    },
    453: {
        excel,
        word,
        power_bi,
        google_data_studio,
        arcgis,
        qgis,
        google_earth_pro,
        tableau,
        d3_js,
        google_sheets,
        spss,
        r,
        google_analytics,
        python,
    },
    49: {
        '3d': threeDimentional,
        flat_minimalist,
        hand_drawn,
        mascot_cartoon,
        signature,
        retro,
        watercolor_feminine,
        geometric,
        lettering,
        view_all,
    },
    371: {
        thumbnails,
        panels,
        overlays_screen_packs,
        emotes_badges,
        banners,
        alerts,
        view_all,
    },
    99: {
        ads_social_media_videos,
        corporate_videos,
        elearning,
        event_videos,
        explainer_videos,
        family_videos,
        gaming_videos,
        movie_trailers,
        music_videos,
        fiction_films,
        showreels,
        vr_360_video,
        youtube_videos,
        view_all,
    },
    163: {
        beauty_fashion,
        business_finance_law,
        health_medical,
        internet_technology,
        lifestyle,
        marketing,
        arabic,
        english,
        french,
        german,
        italian,
        spanish,
        dutch,
        view_all,
    },
    16: {
        arabic,
        english,
        french,
        german,
        italian,
        spanish,
        dutch,
        female,
        male,
        view_all,
    },
    67: {
        facebook,
        instagram,
        linkedin,
        twitter,
        youtube,
        view_all,
    },
    407: {
        facebook,
        instagram,
        linkedin,
        youtube,
        view_all,
    },
    54: {
        marketing,
        investor_pitch_fundraising,
        business_proposal,
        education_training,
        sales,
        conference,
        view_all,
    },
    325: {
        shopify,
        amazon,
        ebay,
        etsy,
        woocommerce,
        view_all,
    },
    139: {
        wix,
        magento,
        opencart,
        squarespace,
        prestashop,
        bigcommerce,
        godaddy,
        sitebuilder,
        webflow,
        shopify,
        amazon,
        ebay,
        woocommerce,
        view_all,
    },
    91: {
        blog,
        business,
        education,
        portfolio,
        entertainment,
        wedding,
        wix,
        magento,
        opencart,
        squarespace,
        prestashop,
        bigcommerce,
        godaddy,
        sitebuilder,
        webflow,
        shopify,
        amazon,
        ebay,
        woocommerce,
        view_all,
    },
    138: {
        blog_magazine: blog,
        corporate: business,
        education,
        portfolio,
        entertainment,
        wedding,
        wix,
        magento,
        opencart,
        squarespace,
        prestashop,
        bigcommerce,
        godaddy,
        sitebuilder,
        webflow,
        shopify,
        amazon,
        ebay,
        woocommerce,
        view_all,
    },
    334: {
        english,
        german,
        french,
        italian,
        spanish,
        view_all,
    },
    249: {
        weddings_events: wedding,
        family_travel: family_videos,
        corporate: corporate_videos,
        sports_games,
        elearning,
        view_all,
    },
    384: {
        english,
        spanish,
        french,
        german,
        arabic,
        view_all,
    },
    156: {
        guitar,
        drums,
        bass,
        piano,
        keyboards,
        violin,
        saxophone,
        trumpet,
        view_all,
    },
    392: {
        pop,
        hip_hop,
        rap,
        r_b,
        edm,
        view_all,
    },
    420: {
        abstract: abstract_pattern,
        digital,
        hand_drawn: hand_drawn_pattern,
        cartoon: cartoon_pattern,
        realistic: realistic_pattern,
        seasonal: watercolor_pattern,
        collage: collage_pattern,
        view_all,
    },
    50: {
        for_children,
        realistic_drawing,
        comic_cartoon,
        manga,
        flat,
        line_art,
        sketch,
        freehand_digital,
        vector_art,
        pen_ink,
        mixed_media,
        watercolor,
        pencil,
        view_all,
    },
    386: {
        photographic,
        illustrative,
        typographic,
        view_all,
    },
    87: {
        mysql,
        ms_sql,
        access,
        oracle,
        sqlite,
        postgres,
        mongo,
        teradata,
        view_all,
    },
    430: {
        fiction,
        non_fiction,
    },
    114: {
        english,
        german,
        spanish,
        french,
    },
    354: {
        english,
        german,
        spanish,
        italian,
        french,
        fiction,
        non_fiction,
        self_help_wellness,
        children_s_books,
        business_management: business,
        science_fiction_fantasy,
        romance,
    },
    435: {
        english,
        spanish,
        german,
        italian,
    },
    200: {
        google,
        bing,
        view_all,
    },
    364: {
        unity,
        unreal_engine,
        fivem,
        roblox: roblox_game_engine,
        godot,
    },
    51: {
        illustrative: illustrative_design_style,
        typographic: typographic_design_style,
        photographic: photographic_design_style,
        minimalistic,
    },
    235: {
        '2d': twoD_animation,
        '3d': threeD_animation,
        stop_motion,
    },
};
